import React from 'react'
import PropTypes from 'prop-types'
import Landscape from './Landscape'
import Footer from '../Home/Footer'
import AppPreview from './AppPreview'
import Subscription from './Subscribe'
import DownloadApp from './DownloadApp'
import QuestionsAnswers from './QuestionsAnswers'
import Optimization from './Optimization'
import Need from './Need'
import { useAnchorAutoScroll } from '../../utils/Utils'

const BeAMaker = () => {
  useAnchorAutoScroll()
  return (
    <div>
      <Landscape />
      <Optimization />
      <AppPreview />
      <Need />
      <QuestionsAnswers />
      <DownloadApp />
      <Subscription />
      <Footer />
    </div>
  )
}

BeAMaker.propTypes = {
  elementToScroll: PropTypes.element,
  scroll: PropTypes.bool,
}

export default BeAMaker
